import axios from "axios";
import qs from "qs";

export const getHotel = async ({ hotelId }) => {
  const { data } = await axios.get(`/api/hotels/${hotelId}.json`);
  return data;
};

export const getTerm = async ({ termId }) => {
  const { data } = await axios.get(`/api/terms/${termId}.json`);
  return data;
};

export const getProduct = async ({ productId }) => {
  const { data } = await axios.get(`/api/products/${productId}.json`);
  return data;
};

export const getRoutes = async ({
  routeStartId,
  routeEndId,
  term1Id,
  term2Id,
  people,
  townId,
}) => {
  const { data } = await axios.get("/api/orders/load_routes.json", {
    params: {
      route_start_id: routeStartId,
      route_end_id: routeEndId,
      term1_id: term1Id,
      term2_id: term2Id,
      people: people,
      town_id: townId,
    },
  });
  return data;
};

export const getAdvance = async ({ seasonId, dateStart }) => {
  const { data } = await axios.get(`/api/seasons/${seasonId}/advances.json`, {
    params: {
      date_start: dateStart,
    },
  });
  return data;
};

export const getRooms = async ({ termId }) => {
  const { data } = await axios.get(`/api/terms/${termId}/rooms.json`);
  return data;
};

export const getRoomConfigs = async ({
  termId,
  adults,
  children,
  roomCount,
  selected,
}) => {
  const { data } = await axios.get(`/api/terms/${termId}/room_configs.json`, {
    params: { adults, children, selected, room_count: roomCount },
  });
  return data;
};

export const getTermMeals = async ({ termId, roomConfig }) => {
  const { data } = await axios.get(`/api/terms/${termId}/meals.json`, {
    params: { room_config: roomConfig },
  });
  return data;
};

export const getOrderServices = async ({ termId }) => {
  const { data } = await axios.get(`/api/terms/${termId}/order_services.json`);
  return data;
};

export const getProgramHotels = async ({ termId, adults, children }) => {
  const { data } = await axios.get(`/api/terms/${termId}/program_hotels.json`, {
    params: {
      adults,
      children,
    },
  });
  return data;
};

export const calculateOrderPrice = async ({ orderDetails }) => {
  console.log(orderDetails);
  const { data } = await axios.get(`/api/orders/calculate_price.json`, {
    params: {
      order: {
        ...orderDetails,
      },
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "brackets" }),
  });
  return data;
};

export const createOrder = async ({ orderDetails }) => {
  const { data } = await axios.post(`/api/orders.json`, {
    order: {
      ...orderDetails,
    },
  });
  return data;
}
